module.exports = __webpack_public_path__ + "media/images/samples/1280x768/13-c1cf0f44c58c468d380e5b21df5ffa38.jpg";